import React from "react";

interface StepItem {
  key: number;
  title: string;
}

interface StepsProps {
  stepsConfig: StepItem[];
  activeStep: number;
}
import './index.less'

const Steps: React.FC<StepsProps> = ({ stepsConfig, activeStep }) => {
  return (
    <div className="steps transfer-process">
      {stepsConfig.map((step, index) => (
        <React.Fragment key={step.key}>
          <div
            className={`step ${Number(activeStep) === step.key ? "active" : ""}`}
          >
            {/* 序号或任何你想展示的内容 */}
            <strong>{index + 1}</strong>
            {/* 显示步骤标题 */}
            <span>{step.title}</span>
          </div>

          {/* 如果不是最后一个步骤，就显示分割线 */}
          {index < stepsConfig.length - 1 && <div className="line"></div>}
        </React.Fragment>
      ))}
    </div>
  );
};

export default Steps;